export enum OrderReservationStatus {
  RESERVED = 'Reservado',
  DONE = 'Entregado',
  TO_CONFIRMED = 'Por Confirmar',
  EXPIRED = 'Expirado',
  CANCELLED = 'Cancelado'
}
